    <template>
      <div class="container mt-5">
          <ErcTokenTable/>
      </div>
    </template>

    <script>
    import ErcTokenTable from "@/views/comp_table/erc_token_table";
    export default {
    name: "erc_two_token",
      components: { ErcTokenTable},
      data(){
        return {
          tokenList:null
        }
      },
      methods:{
       async actionRequest() {
         let v = this
         let result = await v.api('contractErcList',{
           page: 1,
           size: 10000,
           type:1
         },{
           vue: v,
           key_data: 'data',
         })
         // console.log('ERC20 tokenList',result)
         if (result.code==200) {
           this.tokenList=result.data
           this.transTotal=result.data.total
         }
        }
      },
      mounted() {
        this.actionRequest()
      }
    }
    </script>

    <style scoped>

    </style>
